define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Select = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var _excluded = ["data", "disabled", "initialValue", "valueId", "label", "name", "onSelect", "placeholder", "selected", "icon", "required", "dataTestId"];

  var CustomSelect = _styledComponents.default.div.withConfig({
    displayName: "Select__CustomSelect",
    componentId: "sc-1eekba2-0"
  })(["position:relative;width:100%;box-icon[name='chevron-down']{fill:", ";pointer-events:none;position:absolute;right:8px;top:8px;}"], function (_ref) {
    var theme = _ref.theme,
        disabled = _ref.disabled;
    return disabled ? theme.colors.darkGray : theme.colors.primary;
  });

  var SelectStyled = _styledComponents.default.select.withConfig({
    displayName: "Select__SelectStyled",
    componentId: "sc-1eekba2-1"
  })(["appearance:none;background:", ";border:solid 1px ", ";border-radius:2px;color:", ";cursor:pointer;font-size:1.6em;height:40px;line-height:1.4;padding:", ";width:100%;", " &:focus{border:solid 1px ", ";box-shadow:0 0 2px 0 #25bfe7;outline:none;}"], function (_ref2) {
    var theme = _ref2.theme,
        disabled = _ref2.disabled;
    return disabled ? theme.colors.lightGray : theme.colors.white;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.gray;
  }, function (_ref4) {
    var theme = _ref4.theme,
        disabled = _ref4.disabled;
    return disabled ? theme.colors.darkGray : theme.colors.dark;
  }, function (_ref5) {
    var icon = _ref5.icon;
    return icon ? '8px 32px 8px 40px' : '8px 32px 8px 16px';
  }, function (_ref6) {
    var disabled = _ref6.disabled;
    return disabled && (0, _styledComponents.css)(["box-shadow:0 0 2px 0 ", ";cursor:auto;"], function (_ref7) {
      var theme = _ref7.theme;
      return theme.colors.darkGray;
    });
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.blue;
  });

  var IconContainer = _styledComponents.default.span.withConfig({
    displayName: "Select__IconContainer",
    componentId: "sc-1eekba2-2"
  })(["pointer-events:none;position:absolute;left:14px;top:11px;box-icon{fill:", ";width:18px;height:18px;}"], function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.darkGray;
  });

  var Select = function Select(_ref10) {
    var data = _ref10.data,
        disabled = _ref10.disabled,
        initialValue = _ref10.initialValue,
        valueId = _ref10.valueId,
        label = _ref10.label,
        name = _ref10.name,
        onSelect = _ref10.onSelect,
        placeholder = _ref10.placeholder,
        selected = _ref10.selected,
        icon = _ref10.icon,
        required = _ref10.required,
        dataTestId = _ref10.dataTestId,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref10, _excluded);
    return /*#__PURE__*/_react.default.createElement(CustomSelect, (0, _extends2.default)({
      disabled: disabled
    }, rest), icon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: icon.name,
      type: icon.type
    })), /*#__PURE__*/_react.default.createElement(SelectStyled, {
      disabled: disabled,
      value: selected,
      onChange: function onChange(e) {
        return onSelect(e.target.value);
      },
      icon: icon,
      required: required,
      "data-testid": dataTestId
    }, !!placeholder && /*#__PURE__*/_react.default.createElement("option", {
      value: initialValue
    }, placeholder), data.map(function (option) {
      return /*#__PURE__*/_react.default.createElement("option", {
        value: option[valueId],
        key: "" + name + option[valueId]
      }, option[label]);
    })), /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "chevron-down"
    }));
  };

  _exports.Select = Select;
  Select.defaultProps = {
    onSelect: function onSelect() {},
    initialValue: 0,
    data: [],
    valueId: 'id',
    label: 'nome',
    disabled: false
  };
});